/**
 * Design System Context
 *
 * Provides centralized access to typography, colors, and design tokens
 * through React Context.
 */

import React, { createContext, useContext } from "react";
import { designSystem } from "../implementations/DesignSystemImpl";

const DesignSystemContext = createContext();

export const DesignSystemProvider = ({ children }) => {
  return (
    <DesignSystemContext.Provider value={designSystem}>
      {children}
    </DesignSystemContext.Provider>
  );
};

const useDesignSystem = () => {
  const context = useContext(DesignSystemContext);
  if (!context) {
    throw new Error(
      "useDesignSystem must be used within a DesignSystemProvider",
    );
  }
  return context;
};

export const useTypographyHelpers = () => {
  const ds = useDesignSystem();
  return {
    getPrimaryHeading: ds.typography.getPrimaryHeading,
    getSupportingText: ds.typography.getSupportingText,
    getButtonStyles: ds.typography.getButtonStyles,
    getUIStyles: ds.typography.getUIStyles,
  };
};

export const useColorHelpers = () => {
  const ds = useDesignSystem();
  return {
    getInnovationTextClasses: ds.colors.getInnovationTextClasses,
    getHighlightColor: ds.colors.getHighlightColor,
    standardizeHighlightColors: ds.colors.standardizeHighlightColors,
  };
};
